/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";
import Avatar from "pages/_components/Avatar";
import FormattedAmount from "pages/_components/FormattedAmount";
import { useSelector } from "react-redux";
import { statusTagColor } from "util/debin";
import { useParams } from "react-router-dom";
import InfoTag from "../../_components/InfoTag";

const DataDebin = (props) => {
    const {
        debitAccountMask = props.debitAccountMask,
        buyerName = props.buyerName,
        buyerCuit = props.buyerCuit,
        amount = props.amount,
        solicitDate = props.solicitDate,
        dueDate = props.dueDate,
        debinId = props.debinId,
        buyerCbu = props.buyerCbu,
        alias = props.alias,
        bank = props.bank,
        concept = props.concept,
        description = props.description,
        reference = props.reference,
        curency = props.curency,
        creditAccount = props.creditAccount,
        voucher = props.voucher,
        isDesktop = props.isDesktop,
    } = props;

    const { id } = useParams();
    const { sentRequests } = useSelector((state) => state.debin);
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === id);

    const State = () => (
        <InfoTag
            type="info"
            message={receivedDebin?.status?.code}
            tagBackground={statusTagColor(receivedDebin?.status?.code)}
        />
    );
    return (
        <>
            <GridTable className="details debin-credin-list">
                <GridTable.Container columns={3} rows={1}>
                    {!isDesktop && (
                        <GridTable.Data columnStart={1} rowStart={1} columnWidth={1} alignX="flex-end">
                            <State />
                        </GridTable.Data>
                    )}
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={isDesktop ? 1 : 3}>
                        {isDesktop && (
                            <div className="mr-4 flex align-items-end">
                                <Avatar user={{ userFullName: buyerName, defaultAvatarId: 0 }} />
                            </div>
                        )}
                        <CustomData
                            titleText="debin.emitter"
                            titleTextType="I18N"
                            valueText={
                                <>
                                    <CustomText className="data-label" text={`${buyerName} `} />
                                    <br />
                                    {isDesktop ? (
                                        <CustomText className="regular" text={`${buyerCuit} `} />
                                    ) : (
                                        <CustomText className="data-label" text={`${buyerCuit} `} />
                                    )}
                                </>
                            }
                        />
                    </GridTable.Data>

                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 1 : 2}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.details.heading.totalAmount"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={curency} quantity={amount} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 1 : 3}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.dateExpitation"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={debitAccountMask} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data className="flex" columnStart={1} rowStart={isDesktop ? 2 : 4} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 3 : 5} columnWidth={3}>
                        <CustomData
                            titleText="debin.solicit.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={solicitDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 3 : 6}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.expirery.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={dueDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 3 : 7}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.id"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={debinId} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data
                        className="flex"
                        columnStart={1}
                        rowStart={isDesktop ? 4 : 8}
                        columnWidth={isDesktop ? 1 : 3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 9} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.cbu"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={buyerCbu} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 5 : 10}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.alias"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={alias} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 5 : 11}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.bank"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={bank} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 6 : 12} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.concept.label"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={concept} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 6 : 13}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.description.label"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={description} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 6 : 14}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.reference"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={reference} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data className="flex" columnStart={1} rowStart={isDesktop ? 7 : 15} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 8 : 16} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.credit.account"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={creditAccount} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 8 : 17}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.voucher"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={voucher} />}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataDebin.propTypes = {
    debitAccountMask: string,
    buyerName: string,
    buyerCuit: string,
    amount: string,
    solicitDate: string,
    dueDate: string,
    debinId: string,
    buyerCbu: string,
    alias: string,
    bank: string,
    concept: string,
    description: string,
    reference: string,
    curency: string,
    creditAccount: string,
    voucher: string,
    isDesktop: bool,
};

DataDebin.defaultProps = {
    debitAccountMask: "",
    buyerName: "",
    buyerCuit: "",
    amount: "",
    solicitDate: "",
    dueDate: "",
    debinId: "",
    buyerCbu: "",
    alias: "",
    bank: "",
    concept: "",
    description: "",
    reference: "",
    curency: "",
    creditAccount: "",
    voucher: "",
    isDesktop: true,
};

export default DataDebin;
